import { create } from 'zustand';
const useEnvironmentOutput = create(() => ({
    isMobile: false,
    isProduction: false,
    screenOrientationType: undefined,
}));
const reactiveOutput = {
    useIsMobile: () => {
        return useEnvironmentOutput((s) => s.isMobile);
    },
    useIsProduction: () => {
        return useEnvironmentOutput((s) => s.isProduction);
    },
    useScreenOrientationType: () => {
        return useEnvironmentOutput((s) => s.screenOrientationType);
    },
};
export class EnvironmentServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setIsMobile(isMobile) {
        useEnvironmentOutput.setState({ isMobile });
    }
    setIsProduction(isProduction) {
        useEnvironmentOutput.setState({ isProduction });
    }
    setScreenOrientationType(screenOrientationType) {
        useEnvironmentOutput.setState({ screenOrientationType });
    }
}
